import { Component, OnInit } from '@angular/core';
import { TableService } from '@pg-app/partner/dashboard/components/table/table.service';
import { format } from 'date-fns';
import { UtilityService } from '@nttp/common-service/utility-service';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { DATE_FORMAT_POST } from '../constants/date-time-constants';

@Component({
  selector: 'np-table-most-recent-activity',
  templateUrl: './most-recent-activity.component.html'
})

export class TableMostRecentActivityComponent implements OnInit {
  public rows: Array<any> = [];
  columns = [
      {
        title: 'Client Name',
        name: 'clientName',
        width: '200px'
      },
      {
        title: 'Sales Person/BDMRM',
        name: 'salesPerson',
        width: '200px'
      },
      {
        title: 'Date Referred',
        name: 'dateReferred',
        type: TableCellTypes.Date,
        width: '200px'
      },
      {
        title: 'Last contact date',
        name: 'lastContactDate',
        type: TableCellTypes.Date,
        width: '200px'
      },
      {
        title: 'Last activity',
        name: 'lastActivity',
        sort: 'desc',
        type: TableCellTypes.Date,
        width: '180px'
      },
      {
        title: 'Next activity',
        name: 'nextActivityDate',
        type: TableCellTypes.Date,
        width: '180px'
      }
    ];
  constructor(private tableService: TableService) { }

  ngOnInit() {
    this.getTableData();
  }

  public getTableData() {
    const now = new Date();
    const month = now.getMonth();
    const year = now.getFullYear();

    const start = new Date(year, month, 1);
    const end = new Date(year, month + 1, 0);

    const tableData = {
      getAll: true,
      sortName: '',
      sortType: 1,
      fromDate: format(start, DATE_FORMAT_POST),
      toDate: format(end, DATE_FORMAT_POST)
    };

    this.tableService.getTableMostRecentData(tableData).subscribe(
      data => {
        this.rows = data || [];
      },
    );
  }
}
